import { TextInput as MantineTextInput, type TextInputProps as MantineTextInputProps } from '@mantine/core'

export type TextInputProps = MantineTextInputProps

export function TextInput(props: Readonly<TextInputProps>) {
  return <MantineTextInput {...props} />
}
